import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";


const Register = () => {
    const [countries, setCountries] = useState([]);
    const [formData, setFormData] = useState({
        FirstName: '',
        LastName: '',
        Email: '',
        Username: '',
        JobTitle: '',
        Password: '',
        ConfirmPassword: '',
        Country: '',
        Company: '',
    });
    const [error, setError] = useState(null);
    const [passwordsMatch, setPasswordsMatch] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const confirmPasswordRef = useRef(null);
    const navigate = useNavigate();
    // Auto-hide error after 5 seconds
    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => setError(null), 5000);
            return () => clearTimeout(timer);
        }
    }, [error]);

    // Get cookie helper
    function getCookie(name) {
        const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
        return match ? decodeURIComponent(match[2]) : null;
    }

    // Validate passwords live
    const validatePasswordMatch = (password, confirmPassword) => {
        const match = password === confirmPassword;
        setPasswordsMatch(match);

        if (confirmPasswordRef.current) {
            confirmPasswordRef.current.setCustomValidity(
                match ? "" : "Passwords do not match"
            );
        }
    };

    // Fetch country list
    useEffect(() => {
        const populateCountryDropdown = async () => {
            try {
                const response = await fetch("https://restcountries.com/v3.1/all");
                const data = await response.json();
                const sortedCountries = data.sort((a, b) =>
                    a.name.common.localeCompare(b.name.common)
                );
                setCountries(sortedCountries);
            } catch (error) {
                console.error("Error fetching country data:", error);
            }
        };

        populateCountryDropdown();
    }, []);

    // Handle form inputs
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevData) => {
            const newData = { ...prevData, [name]: value };
            if (name === "Password" || name === "ConfirmPassword") {
                validatePasswordMatch(newData.Password, newData.ConfirmPassword);
            }
            return newData;
        });
    };

    // Submit form
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const xmas_token = getCookie("xmas_token");
        const customer_id = getCookie("customer_id");
        const customer_identifier = getCookie("customer_identifier");
        const product_code = getCookie("product_code");
        const dimension_identifier = getCookie("dimension");

        if (!xmas_token || !customer_id || !customer_identifier || !product_code) {
            setError("Missing required data. Please start from the beginning.");
            return;
        }

        if (formData.Password !== formData.ConfirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        const randomDigits = Math.floor(10000 + Math.random() * 90000);
        const order_name = `${randomDigits}_${formData.Username}`;

        const fullPayload = {
            order_name,
            user_name: formData.Username,
            password: formData.Password,
            confirm_password: formData.ConfirmPassword,
            email: formData.Email, 
            contact_name: `${formData.FirstName} ${formData.LastName}`,
            company: formData.Company,
            country: formData.Country,
            job_title: formData.JobTitle,
            dimension_identifier: dimension_identifier,
            xmas_token,
            customer_id: customer_identifier,
            customer_indetifier: customer_id,
            product_code,
            subscription_name: "Tiger Bridge Dev",
        };

        try {
            const response = await fetch("https://halr7m1u21.execute-api.us-east-1.amazonaws.com/dev/license", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(fullPayload),
            });

            const result = await response.json();
            if (!result.success) {
                throw new Error(result.error_message || "Something went wrong");
            }

            navigate("/success", {
                state: { customerName: formData.Username }
            });
        } catch (error) {
            setError(error.message);
        } finally {
            setIsSubmitting(false); // Always re-enable after request
        }
    };

    return (
        <div className="form_wrapper">
            <div className="content">
                <div className="main_content">
                    <div className="form_text">
                        <h3>Step 2: Register with a Tiger Technology account</h3>
                        <p>
                            Please complete the form below with the required information.
                            Once finished, you'll be prompted to log in to your Tiger Licensing account.
                        </p>
                        <br></br>
                        <div class="requered_info">
                            <p>* Required Information</p>
                        </div>
                        <div className="form_container">

                            {/* Error alert */}
                            {error && (
                                <div className="alertMessage alert alert-danger d-flex align-items-center" role="alert">
                                    <img
                                        className="alert-icon"
                                        src="/img/Account_Authentication_Error_Icon_60x60.svg"
                                        alt=""
                                    />
                                    <div>{error}</div>
                                </div>
                            )}
                            <form onSubmit={handleFormSubmit}>
                                {/* First & Last Name */}
                                <article className="tiger-input-group">
                                    <div className="form-group">
                                        <label className="form_label">First Name*</label>
                                        <input
                                            type="text"
                                            name="FirstName"
                                            value={formData.FirstName}
                                            onChange={handleInputChange}
                                            className="form_input"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form_label">Last Name*</label>
                                        <input
                                            type="text"
                                            name="LastName"
                                            value={formData.LastName}
                                            onChange={handleInputChange}
                                            className="form_input"
                                            required
                                        />
                                    </div>
                                </article>

                                {/* Email & Username */}
                                <article className="tiger-input-group">
                                    <div className="form-group">
                                        <label className="form_label">Email*</label>
                                        <input
                                            type="text"
                                            name="Email"
                                            value={formData.Email}
                                            onChange={handleInputChange}
                                            className="form_input"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form_label">Username*</label>
                                        <input
                                            type="text"
                                            name="Username"
                                            value={formData.Username}
                                            onChange={handleInputChange}
                                            className="form_input"
                                            required
                                        />
                                    </div>
                                </article>

                                {/* Passwords */}
                                <article className="tiger-input-group">
                                    <div className="form-group">
                                        <label className="form_label">Password*</label>
                                        <input
                                            type="password"
                                            name="Password"
                                            value={formData.Password}
                                            onChange={handleInputChange}
                                            className={`form_input ${!passwordsMatch ? "border-red-500" : ""}`}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form_label">Confirm Password*</label>
                                        <input
                                            type="password"
                                            name="ConfirmPassword"
                                            value={formData.ConfirmPassword}
                                            onChange={handleInputChange}
                                            className={`form_input ${!passwordsMatch ? "border-red-500" : ""}`}
                                            required
                                            ref={confirmPasswordRef}
                                        />
                                        {!passwordsMatch && (
                                            <p className="text-red-500 text-sm mt-1">
                                                Passwords do not match
                                            </p>
                                        )}
                                    </div>
                                </article>

                                {/* Country & Company */}
                                <article className="tiger-input-group">
                                    <div className="form-group">
                                        <label className="form_label">Country</label>
                                        <select
                                            name="Country"
                                            value={formData.Country}
                                            onChange={handleInputChange}
                                            className="form_input"
                                        >
                                            <option value="">Select a country</option>
                                            {countries.map((country) => (
                                                <option key={country.cca2} value={country.name.common}>
                                                    {country.name.common}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label className="form_label"></label>

                                    </div>
                                </article>

                                {/* Job Title */}
                                <article className="tiger-input-group">
                                    <div className="form-group">
                                        <label className="form_label">Company Name*</label>
                                        <input
                                            type="text"
                                            name="Company"
                                            value={formData.Company}
                                            onChange={handleInputChange}
                                            className="form_input"
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="form_label">Job Title</label>
                                        <input
                                            type="text"
                                            name="JobTitle"
                                            value={formData.JobTitle}
                                            onChange={handleInputChange}
                                            className="form_input"
                                        />
                                    </div>
                                </article>
                                {/* Submit Button */}
                                <div className="tiger-btn-placement-alt">
                                    <button
                                        type="submit"
                                        className="primary-tiger-button"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? "Submitting..." : "Register to complete order"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;
